import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'components/_UI/Button'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import { useUser } from 'context/user/User'
import paths from 'routes/paths'
import colors from 'theme/colors'
import routeParams from 'theme/routeParams'
import useAcceptedInviteRedirect from 'modules/dashboard/producer-access/useAcceptedInviteRedirect'

/**
 * Resposta do link do e-mail de permissão no evento. Aceitou: vai para o
 * painel do produtor quando o acesso dele libera o painel; sem isso, o botão
 * leva para a tela de validação.
 */
export default function InvitePermissionAlert({ visible, data, onClose }) {
    const navigate = useNavigate()
    const { user } = useUser()

    const { redirecting } = useAcceptedInviteRedirect({
        active: !!visible && data?.type == 'accept',
        producerId: data?.producerId,
        inviteParams: new URLSearchParams({
            [routeParams.permissions.invitePermission]: 'accept',
            [routeParams.permissions.invitePermissionEvent]: data?.event || '',
            [routeParams.permissions.invitePermissionProducer]: data?.producerId || '',
        }),
    })

    function openCheckin() {
        onClose()
        navigate(paths.checkin)
    }

    if (redirecting) return null

    return (
        <Modal isOpen={!!visible} closeButton={true} onClose={onClose}>
            {
                data?.type == 'accept' && (
                    <>
                        <Text name='normal' type='bold' color={colors.successLight}>
                            Convite aceito
                        </Text>

                        <Text color={colors.night}>
                            Parabéns! Agora você tem permissão para validação no evento <b>"{data?.event}"</b>.
                        </Text>

                        {
                            user?.have_permission_to_checkin && (
                                <Button variant='lightBlue' category='roundedBorded' marginTop={'16px'} onClick={openCheckin}>
                                    Ir para a validação
                                </Button>
                            )
                        }
                    </>
                )
            }

            {
                data?.type == 'reject' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Convite recusado
                        </Text>

                        <Text color={colors.night}>
                            Você recusou o convite para ter permissão de validação no evento <b>"{data?.event}"</b>.
                        </Text>
                    </>
                )
            }

            {
                data?.type == 'error' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Ocorreu um erro
                        </Text>

                        <Text color={colors.night}>
                            Ocorreu um erro inesperado durante o seu convite, entre em contato com o responsavel do evento.
                        </Text>
                    </>
                )
            }
        </Modal>
    )
}
